import React from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { EmptySourcesIcon } from './EmptySourcesIcon';

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		alignSelf: 'stretch',
		gap: token('space.200'),
	},
	text: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: token('space.100'),
		textAlign: 'center',
	},
});

export type EmptySourcesStateProps = {
	title: string;
	description: string;
	/** Optional action rendered below the description (e.g. an "Add sources" button). */
	action?: React.ReactNode;
	/** Size of the heading — use 'medium' for full-screen, 'xsmall' for modal. Defaults to 'medium'. */
	headingSize?: 'medium' | 'xsmall';
	testId?: string;
};

/**
 * Reusable empty-sources state used in both the Space landing page and the Manage Space modal.
 * Renders the decorative icon, a heading, body text, and an optional action (e.g. "Add sources" button).
 */
export const EmptySourcesState = ({
	title,
	description,
	action,
	headingSize = 'medium',
	testId,
}: EmptySourcesStateProps): React.JSX.Element => (
	<Box xcss={styles.container} testId={testId}>
		<EmptySourcesIcon />
		<Box xcss={styles.text}>
			<Heading size={headingSize}>{title}</Heading>
			<Text color="color.text.subtle">{description}</Text>
		</Box>
		{action}
	</Box>
);
